
const LivestreamTransaction = () =>
  import('@/views/main/inspect/livestreamTransaction/livestreamTransaction.vue')
export default {
  path: '/main/inspect/livestreamTransaction',
  name: 'livestreamTransaction',
  component: LivestreamTransaction,
  children: []
}